import { type Question } from '@/types'

import { generateSpanField } from './generateSpanField'
import { getQuestionInfo } from './getQuestionInfo'

const extractValuesFromParentheses = (formula: string) => {
  const parenthesesRegex = formula.replace(/^IF\(|\)$/g, '').split(';')

  return parenthesesRegex
}

const extractTokensFromExpression = (expression: string) => {
  const tokenRegex = /([QR]\d+|\d+\.\d+|\d+|[()+\-*/=><])/g
  const tokenMatch = expression.match(tokenRegex)
  return tokenMatch
}

export const generateIF = (questions: Question[], formula: string) => {
  const valuesInsideParentheses = extractValuesFromParentheses(formula)

  if (!valuesInsideParentheses) return ''

  const processedValues = valuesInsideParentheses?.map((value) => {
    const tokens = extractTokensFromExpression(value)
    return tokens || []
  })

  return `<span
      data-description="Click to change function"
      data-function="if"
      data-type="function"
    >
      IF
    </span>
    <span data-type="parentheses">(</span>
    <span
      data-description="Click and type a condition"
      data-type="wrapperPlaceholder"
    >
      <span data-type="placeholder" style="display: none;">
        add condition
      </span>
      <span
        contenteditable="true"
        data-description="Click and type to add a value when true"
        data-mask="input"
        data-order="3"
        data-type="condition"
      >
      ${processedValues?.[0]
        .map((token) => {
          if (/^[QR]/.test(token)) {
            const tokenInfo = getQuestionInfo(questions, token)
            return generateSpanField({
              description: tokenInfo?.description || '',
              type: 'addedField',
              value: token,
            })
          }
          return token
        })
        .join('')}
      </span>
    </span>
    <span data-type="semicolon">;</span>
    <span
      data-description="Click and type to add a value when true"
      data-type="wrapperPlaceholder"
    >
      <span data-color="green" data-type="placeholder" style="display: none;">
        value when true
      </span>
      <span
        contenteditable="true"
        data-description="Click and type to add a value when true"
        data-mask="input"
        data-order="4"
        data-type="whenTrue"
      >
      ${processedValues?.[1]
        ?.map((token) => {
          if (/^[QR]/.test(token)) {
            const tokenInfo = getQuestionInfo(questions, token)
            return generateSpanField({
              description: tokenInfo?.description || '',
              type: 'addedField',
              value: token,
            })
          }
          return token
        })
        .join('')}
      </span>
    </span>
    <span data-type="semicolon">;</span>
    <span
      data-description="Click and type to add a value when false"
      data-type="wrapperPlaceholder"
    >
      <span data-color="red" data-type="placeholder" style="display: none;">
        value when false
      </span>
      <span
        contenteditable="true"
        data-description="Click and type to add a value when false"
        data-mask="input"
        data-order="5"
        data-type="whenFalse"
      >
      ${processedValues?.[2]
        ?.map((token) => {
          if (/^[QR]/.test(token)) {
            const tokenInfo = getQuestionInfo(questions, token)
            return generateSpanField({
              description: tokenInfo?.description || '',
              type: 'addedField',
              value: token,
            })
          }
          return token
        })
        .join('')}
      </span>
    </span>
    <span data-type="parentheses">)</span>`
}
